import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BaseStoreEntityType, baseStoreEntityValue } from 'src/store/types';
import { UserModel } from 'src/models/Account/User';

export type CurrentUserStateType = BaseStoreEntityType<UserModel | null>;

const initialState: CurrentUserStateType = baseStoreEntityValue(null, true);

export const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    getCurrentUserStart: (state) => {
      state.loading = true;
      state.response = null;
    },
    getCurrentUserOk: (state, { payload }: PayloadAction<UserModel | null>) => {
      state.response = payload;
      state.loading = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clearCurrentUser: (state, { payload }: PayloadAction<boolean>) => {
      state.response = null;
      state.loading = false;
    },
    getCurrentUserError: (state, { payload }: PayloadAction<string>) => {
      state.error = payload;
      state.loading = true;
    },
    changeInfo: (state, { payload }: PayloadAction<Partial<UserModel>>) => {
      if (state.response) {
        state.response = { ...state.response, ...payload };
      }
    },
  },
});
